import http from "@/http-common";
import AttributeSet, {AttributeSetDTO} from "@/api/AttributeSet";
import Product, {ProductDTO} from "@/api/Product";
import Brand, {BrandDTO} from "@/api/Brand";
import CompareSearch from "@/api/Compare/CompareSearch";
import PostRequestInterface from "@/request/PostRequestInterface";

class CompareService {
    async getAttributeSet(id: number): Promise<AttributeSet> {
        const queryParams = {
            id: id
        };
        const url = '/bcatalog/compareAjax/getAttributeSet';
        const response = await http.get<AttributeSetDTO>(url, {params: queryParams});
        return new AttributeSet(response.data);
    }

    async getProductsById(ids: number[]): Promise<Product[]> {
        const queryParams = {
            ids: ids.join("-")
        };
        const url = '/bcatalog/compareAjax/getProductsById';
        const response = await http.get<ProductDTO[]>(url, {params: queryParams});
        return response.data.map(productDTO => new Product(productDTO));
    }

    async getBrandsBySetId(setId: number): Promise<Brand[]> {
        const queryParams = {
            id: setId
        };
        const url = '/bcatalog/compareAjax/getBrandsBySetId';
        const response = await http.get<BrandDTO[]>(url, {params: queryParams});
        return response.data.map(brandDTO => new Brand(brandDTO));
    }

    async getProductsByBrandsAndSetId(compareSearch: CompareSearch): Promise<Product[]> {
        const queryParams: { [k: string]: string } = {};
        if (compareSearch.attributeSetId) {
            queryParams.setId = compareSearch.attributeSetId.toString();
        }
        if (compareSearch.brandId) {
            queryParams.brandId = compareSearch.brandId.toString();
        }
        if (compareSearch.searchString && compareSearch.searchString.length > 0) {
            queryParams.q = compareSearch.searchString;
        }

        const url = '/bcatalog/compareAjax/getProductsByBrandsAndSetId';
        const response = await http.get<ProductDTO[]>(url, {params: queryParams});
        return response.data.map(productDTO => new Product(productDTO));
    }

    async addProduct(setId: number, productId: number): Promise<PostRequestInterface> {
        const queryParams: { [k: string]: string } = {};
        queryParams.setId = setId.toString();
        queryParams.productId = productId.toString();

        const url = '/bcatalog/compareAjax/add';
        const response = await http.get<PostRequestInterface>(url, {params: queryParams});
        return response.data;
    }

    async removeProduct(setId: number, productId: number): Promise<PostRequestInterface> {
        const queryParams: { [k: string]: string } = {};
        queryParams.setId = setId.toString();
        queryParams.productId = productId.toString();

        const url = '/bcatalog/compareAjax/remove';
        const response = await http.get<PostRequestInterface>(url, {params: queryParams});
        return response.data;
    }
}

export default new CompareService();